import { HttpRequest, HttpHandler, HttpEvent, HttpInterceptor, HttpErrorResponse, HttpResponse } from '@angular/common/http';
import { Injectable } from "@angular/core";
import { map, tap, catchError } from 'rxjs/operators';
import { Observable, throwError } from 'rxjs';
import { CommonService } from 'huddyapi'
import { Time } from 'huddyapi';
import { TempAuthService } from './tempAuthService';
import { DesktopErrorHandler } from './errorHandler.service';


@Injectable()
export class DesktopHttpInterceptor implements HttpInterceptor {
  loggingOut: boolean;

  constructor(
    private authService: TempAuthService,
    public commonService: CommonService,
    public errorHandler: DesktopErrorHandler
  ) {
    this.loggingOut = false;
  }

  intercept(request: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    const startTime: Time = new Time();
    const modifiedReq = request.clone();
    return next.handle(modifiedReq).pipe(map((event: HttpEvent<any>): HttpEvent<any> => {
      if(event instanceof HttpResponse)
        return this.handleResponse(modifiedReq, event, startTime.elapsed(new Date()));
      return event;
    }), tap(), catchError((error: any) => {
      if(error instanceof HttpErrorResponse)
        return throwError(this.handleError(modifiedReq, error, startTime.elapsed(new Date())));
      return throwError(error);
    }));
  }

  handleResponse(request: HttpRequest<any>, response: HttpResponse<any>, elapsed: number): HttpResponse<any> {
    return response.clone({
      headers: response.headers.append('x-elapsed-ms', elapsed.toString())
    });
  }

  handleError(request: HttpRequest<any>, error: HttpErrorResponse, elapsed: number): HttpErrorResponse {
    let handled: boolean = false;
    const authorization: string = request.headers.get('authorization');
    if(!authorization && error?.status == 401 && error.error?.AuthenticationException?.endsWith('has no active seats with a provider')) {
      handled = true;
      this.errorHandler.handle('Missing CompassBuilder license');
    }
    if(authorization && (error.status == 401 || (error.status < 200 || error.status >= 300) && error.url.indexOf("/account") > -1)) {
      handled = true;
      if(!this.loggingOut && authorization == CommonService.jwt) {
        this.errorHandler.handle('Session expired');
        this.logOut();
      }
    }
    return new HttpErrorResponse({
      ...error,
      headers: error.headers
        .append('x-elapsed-ms', elapsed.toString())
        .append('x-handled', handled.toString())
        .append('x-date-received', new Time().timeStr)
        .append('x-request-method', request.method)
    });
  }

  logOut() {
    this.loggingOut = true;
    this.authService.logOut().catch((error: any) => {
      this.errorHandler.handle(error, 'logout', DesktopErrorHandler.COMMON_MESSAGES);
    }).finally(() => this.loggingOut = false);
  }
}
